import React from "react";
import { Route, Switch } from "react-router-dom";

import MyTasksPage from "./MyTasksPage";

export const TASKS_ROUTES = {
  MY_TASKS: "/my-tasks",
};

export function TasksRoutes() {
  return (
    <Switch>
      <Route exact path={TASKS_ROUTES.MY_TASKS}>
        <MyTasksPage />
      </Route>
    </Switch>
  );
}
